export default __webpack_public_path__ + "static/media/function-1.94ee932c.png";